import React from "react";
import { ExternalLink } from "lucide-react";
import { useApp } from "@/context/AppContext";

const WEBSITE = "https://vk-apps.de/";

export const Footer = () => {
  const { t } = useApp();

  return (
    <footer className="mt-12 border-t border-border" data-testid="app-footer">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        {/* Anzeigen / Werbung */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Anzeige 1: Tarifcheck.de */}
          <a
            href="https://a.partner-versicherung.de/click.php?partner_id=190328&ad_id=2"
            target="_blank"
            rel="sponsored noopener noreferrer"
            data-testid="ad-tarifcheck"
            className="group relative block rounded-2xl border border-border bg-card p-4 overflow-hidden hover:shadow-md transition-all"
          >
            <span className="absolute top-2 right-3 text-[10px] uppercase tracking-widest text-muted-foreground/70">
              {t("ad")}
            </span>
            <img
              src="https://a.partner-versicherung.de/view.php?partner_id=190328&ad_id=2"
              alt="Tarifcheck.de – Versicherungen & Tarife vergleichen"
              className="w-full h-auto rounded-lg"
              loading="lazy"
            />
            <p className="mt-3 text-sm text-muted-foreground">{t("tarifcheckText")}</p>
          </a>

          {/* Anzeige 2: Octopus Energy */}
          <a
            href="https://share.octopusenergy.de/mellow-loris-590"
            target="_blank"
            rel="sponsored noopener noreferrer"
            data-testid="ad-octopus"
            className="group relative flex flex-col rounded-2xl border border-border bg-card p-5 hover:shadow-md transition-all"
          >
            <span className="absolute top-2 right-3 text-[10px] uppercase tracking-widest text-muted-foreground/70">
              {t("ad")}
            </span>
            <img
              src="https://vk-apps.de/assets/octopus-energy-logo.svg"
              alt="Octopus Energy"
              className="h-8 w-auto self-start mb-3"
              loading="lazy"
            />
            <p className="text-base font-semibold text-foreground">{t("octopusTitle")}</p>
            <p className="mt-1 text-sm text-muted-foreground flex-1">{t("octopusSub")}</p>
            <span className="mt-4 inline-flex items-center justify-center h-10 px-4 rounded-xl bg-[#180048] text-white text-sm font-semibold group-hover:brightness-125 transition-all self-start">
              {t("octopusCta")}
            </span>
          </a>
        </div>

        {/* Website-Button + Copyright */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            {t("createdBy")}{" "}
            <a
              href={WEBSITE}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-foreground hover:text-primary transition-colors"
            >
              VK Apps
            </a>{" "}
            · Volkan Kurt, Lahr
          </p>
          <a
            href={WEBSITE}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="website-btn"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-primary text-primary-foreground font-semibold hover:brightness-110 active:scale-[0.98] transition-all shadow-sm"
          >
            <ExternalLink className="w-4 h-4" />
            {t("visitWebsite")}
          </a>
        </div>
      </div>
    </footer>
  );
};
